/* Sapone Di Toscana — Lux interactions
 * Kleine, afhankelijkheidsvrije scripts: reveal, woord-animatie, parallax,
 * transparante header, collectie-rail, snel toevoegen, sticky koopbalk,
 * ritueel-stappen en collectiefilters. Respecteert prefers-reduced-motion.
 */
(function () {
  'use strict';
  var doc = document;
  var body = doc.body;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var motion = body.classList.contains('sdt-motion') && !reduced;
  /* Teksten komen uit de locale-bestanden (window.sdtStrings, zie layout/theme.liquid); Nederlands is de terugvaloptie. */
  function S(key, fallback) { var o = window.sdtStrings; return o && typeof o[key] === 'string' ? o[key] : fallback; }
  function fmt(str, map) { return str.replace(/\[(\w+)\]/g, function (m, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m; }); }

  /* ---------- Reveal ---------- */
  function splitWords(el) {
    if (el.dataset.split === 'done') return;
    var walker = doc.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    var i = 0;
    nodes.forEach(function (node) {
      var parts = node.textContent.split(/(\s+)/);
      var frag = doc.createDocumentFragment();
      parts.forEach(function (p) {
        if (!p) return;
        if (/^\s+$/.test(p)) { frag.appendChild(doc.createTextNode(p)); return; }
        var w = doc.createElement('span'); w.className = 'lux-w';
        var inner = doc.createElement('span'); inner.textContent = p; inner.style.setProperty('--i', i++);
        w.appendChild(inner); frag.appendChild(w);
      });
      node.parentNode.replaceChild(frag, node);
    });
    el.dataset.split = 'done';
    el.classList.add('lux-split');
  }

  function initReveal(root) {
    var els = (root || doc).querySelectorAll('[data-reveal], [data-split]');
    if (!motion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    els.forEach(function (el) { if (el.hasAttribute('data-split')) splitWords(el); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Parallax ---------- */
  var plx = [];
  function initParallax() {
    if (!motion) return;
    plx = Array.prototype.slice.call(doc.querySelectorAll('[data-parallax]'));
    if (!plx.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      plx.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var speed = parseFloat(el.dataset.parallax) || 0.12;
        var center = r.top + r.height / 2 - vh / 2;
        el.style.transform = 'translate3d(0,' + (-center * speed).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Transparante header ---------- */
  function initHeader() {
    var header = doc.querySelector('.section-header');
    var hero = doc.querySelector('[data-lux-hero]');
    if (!header) return;
    var service = doc.querySelector('.sdt-service-section');
    function setService() {
      var h = service ? service.getBoundingClientRect().height : 0;
      doc.documentElement.style.setProperty('--lux-service-h', h + 'px');
      return h;
    }
    var overlay = hero && hero.dataset.luxHero === 'transparent' && body.classList.contains('sdt-t-index');
    if (!overlay) return;
    body.classList.add('sdt-header-over');
    var serviceH = setService();
    var solid = false;
    function onScroll() {
      var y = window.scrollY;
      body.classList.toggle('lux-scrolled', y > serviceH);
      var limit = hero.offsetHeight - header.offsetHeight - serviceH - 40;
      var shouldSolid = y > limit || header.classList.contains('menu-open') || header.matches(':focus-within') && header.querySelector('details[open]');
      if (shouldSolid !== solid) { solid = !!shouldSolid; header.classList.toggle('lux-solid', solid); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { serviceH = setService(); onScroll(); });
    header.addEventListener('mouseenter', function () { header.classList.add('lux-solid'); });
    header.addEventListener('mouseleave', function () { onScroll(); if (!solid) header.classList.remove('lux-solid'); });
    doc.addEventListener('click', function () { setTimeout(onScroll, 50); });
    var drawer = header.querySelector('header-drawer details');
    if (drawer) drawer.addEventListener('toggle', function () { header.classList.toggle('lux-solid', drawer.open || solid); });
    onScroll();
  }

  /* ---------- Rail (collectie-carrousel) ---------- */
  function initRails() {
    doc.querySelectorAll('[data-lux-rail]').forEach(function (wrap) {
      var rail = wrap.querySelector('.lux-show__rail');
      var bar = wrap.querySelector('.lux-show__progress span');
      var prev = wrap.querySelector('[data-rail-prev]');
      var next = wrap.querySelector('[data-rail-next]');
      if (!rail) return;
      function step() { var c = rail.querySelector(':scope > *'); return c ? c.getBoundingClientRect().width + 24 : 300; }
      function upd() {
        var max = rail.scrollWidth - rail.clientWidth;
        var ratio = rail.clientWidth / rail.scrollWidth;
        if (bar) {
          bar.parentElement.hidden = max <= 2;
          bar.style.setProperty('--p', (ratio * 100).toFixed(2) + '%');
          var track = bar.parentElement.clientWidth * (1 - ratio);
          bar.style.setProperty('--x', (max > 0 ? (rail.scrollLeft / max) * track : 0).toFixed(1) + 'px');
        }
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max - 2;
      }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' }); });
      rail.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  /* ---------- Snel toevoegen ---------- */
  function addToCart(variantId, qty, btn) {
    var cart = doc.querySelector('cart-drawer') || doc.querySelector('cart-notification');
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', qty || 1);
    if (cart && cart.getSectionsToRender) {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(btn);
    }
    var label = btn ? btn.querySelector('[data-label]') : null;
    var original = label ? label.textContent : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('is-loading'); if (label) label.textContent = btn.dataset.loading || S('loading', 'Toevoegen…'); }
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || S('error', 'Er ging iets mis.'));
        try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sdt-quick-add', productVariantId: variantId, cartData: res }); } catch (e) { /* pubsub niet beschikbaar */ }
        if (cart && cart.renderContents) {
          cart.classList.remove('is-empty');
          var inner = cart.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty');
          cart.renderContents(res);
        }
        /* sdt: op /cart (zonder drawer) ververst <cart-items> zichzelf via het cartUpdate-event hierboven. */
        else if (!doc.querySelector('cart-items')) window.location = (window.routes && window.routes.cart_url) || '/cart';
        var bubble = doc.getElementById('cart-icon-bubble');
        if (bubble && motion) { bubble.classList.remove('lux-bump'); void bubble.offsetWidth; bubble.classList.add('lux-bump'); }
        if (label) label.textContent = btn.dataset.added || S('added', 'Toegevoegd');
        setTimeout(function () { if (label) label.textContent = original; }, 2200);
      })
      .catch(function (err) {
        if (label) label.textContent = original;
        var msg = btn && btn.closest('[data-lux-quick]') ? btn.closest('[data-lux-quick]').querySelector('[data-quick-error]') : null;
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
        else alertSafe(err.message);
      })
      .finally(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('is-loading'); } });
  }
  function alertSafe(m) { var live = doc.getElementById('lux-live'); if (live) live.textContent = m; }
  window.SDTLux = window.SDTLux || {};
  window.SDTLux.addToCart = addToCart;

  doc.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;
    addToCart(btn.dataset.quickAdd, 1, btn);
  });

  /* ---------- Sticky koopbalk (mobiel) ---------- */
  function initStickyAtc() {
    var bar = doc.querySelector('[data-lux-sticky-atc]');
    if (!bar) return;
    var form = doc.querySelector('product-form form[action*="/cart/add"]');
    var submit = form ? form.querySelector('[type=submit]') : null;
    if (!submit) { bar.remove(); return; }
    var btn = bar.querySelector('button');
    bar.inert = true;
    btn.addEventListener('click', function () {
      if (submit.disabled || submit.getAttribute('aria-disabled') === 'true') { submit.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' }); return; }
      submit.click();
    });
    function sync() {
      var label = submit.querySelector('span');
      var target = bar.querySelector('[data-label]');
      if (!target.dataset.default) target.dataset.default = target.textContent.trim();
      target.textContent = (submit.disabled && label) ? label.textContent.trim() : target.dataset.default;
      btn.disabled = !!submit.disabled;
    }
    new MutationObserver(sync).observe(submit, { attributes: true, childList: true, subtree: true });
    sync();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0];
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        var vis = bar.classList.contains('is-visible'); bar.setAttribute('aria-hidden', vis ? 'false' : 'true'); bar.inert = !vis;
      }).observe(submit);
    }
    var priceEl = doc.querySelector('.product__info-container .price-item--regular, .product__info-container .price-item--sale');
    var priceTarget = bar.querySelector('[data-price]');
    if (priceEl && priceTarget) new MutationObserver(function () { priceTarget.textContent = priceEl.textContent.trim(); }).observe(priceEl, { childList: true, characterData: true, subtree: true });
  }

  /* ---------- Ritueel: actieve stap + wisselend beeld ---------- */
  function initRitual() {
    doc.querySelectorAll('[data-lux-ritual]').forEach(function (root) {
      var steps = root.querySelectorAll('.lux-step');
      var imgs = root.querySelectorAll('[data-step-img]');
      if (!steps.length || !('IntersectionObserver' in window)) { steps.forEach(function (s) { s.classList.add('is-active'); }); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var idx = Array.prototype.indexOf.call(steps, e.target);
          steps.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
          imgs.forEach(function (im, i) { im.style.opacity = (i === Math.min(idx, imgs.length - 1)) ? 1 : 0; });
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { io.observe(s); });
      steps[0].classList.add('is-active');
    });
  }

  /* ---------- Collectiefilter (geurfamilie) + sortering ---------- */
  function initCollection() {
    doc.querySelectorAll('[data-lux-collection]').forEach(function (root) {
      var chips = root.querySelectorAll('.lux-chip');
      var cards = root.querySelectorAll('.lux-coll-grid > [data-family]');
      var count = root.querySelector('[data-count]');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var f = chip.dataset.filter;
          chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
          var n = 0;
          cards.forEach(function (card) {
            var show = !f || (' ' + card.dataset.family + ' ').indexOf(' ' + f + ' ') !== -1;
            card.hidden = !show; if (show) n++;
          });
          if (count) count.textContent = fmt(n === 1 ? S('countOne', '[count] geur') : S('countOther', '[count] geuren'), { count: n });
        });
      });
      var sort = root.querySelector('[data-sort]');
      if (sort) sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        window.location.href = url.toString();
      });
    });
  }

  /* ---------- Quiz: start met vooraf gekozen sfeer (?geur=...) ---------- */
  function initQuizPreset() {
    var quiz = doc.querySelector('sdt-quiz');
    if (!quiz) return;
    var p = new URLSearchParams(window.location.search).get('q1');
    if (!p) return;
    var tries = 0;
    (function pick() {
      var input = quiz.querySelector('input[name="q1"][value="' + CSS.escape(p) + '"]');
      if (!input) { if (tries++ < 20) setTimeout(pick, 100); return; }
      input.checked = true;
      var form = input.closest('form');
      if (form && form.requestSubmit) form.requestSubmit();
      quiz.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    })();
  }

  function ready(fn) { if (doc.readyState !== 'loading') fn(); else doc.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var live = doc.createElement('p'); live.id = 'lux-live'; live.className = 'lux-sr'; live.setAttribute('aria-live', 'polite'); body.appendChild(live);
    initReveal();
    initParallax();
    initHeader();
    initRails();
    initStickyAtc();
    initRitual();
    initCollection();
    initQuizPreset();
  });
  doc.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initRails(); initRitual(); initCollection(); });
})();
